import gsap from 'gsap';

const selectors = {
  el: '.js-magnetic:not(.is-initialized)'
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  els.forEach(el => {
    el.classList.add('is-initialized');

    el.addEventListener('mousemove', e => {
      const rect = el.getBoundingClientRect();
      const relX = e.clientX - rect.left;
      const relY = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const moveX = (relX - centerX) * 0.2;
      const moveY = (relY - centerY) * 0.2;
      
      gsap.to(el, {
        x: moveX,
        y: moveY,
        ease: 'power3.out',
        duration: 0.5
      });
    });

    el.addEventListener('mouseleave', () => {
      gsap.to(el, {
        x: 0,
        y: 0,
        ease: 'power3.out',
        duration: 0.5
      });
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;